/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Exercise_Sheet_Percent_NoteInputs */

const en_us2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Worked out from your estimated max strength (${i?.loadText}), the weight you could lift once. Programmes often ask for a percentage of it, such as 75%.`)
};

const pt_br2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calculado da sua força máxima estimada (${i?.loadText}), o peso que você levantaria uma única vez. Treinos costumam pedir uma porcentagem dela, como 75%.`)
};

const es_419_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calculado a partir de tu fuerza máxima estimada (${i?.loadText}), el peso que podrías levantar una sola vez. Los programas suelen pedir un porcentaje de ella, como el 75%.`)
};

const pt_pt2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calculado a partir da tua força máxima estimada (${i?.loadText}), o peso que levantarias uma única vez. Os planos de treino pedem muitas vezes uma percentagem dela, como 75%.`)
};

const fr_fr2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calculé à partir de ta force max estimée (${i?.loadText}), la charge que tu pourrais soulever une seule fois. Les programmes en demandent souvent un pourcentage, comme 75 %.`)
};

const de_de2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berechnet aus deiner geschätzten Maximalkraft (${i?.loadText}), dem Gewicht, das du einmal heben könntest. Trainingspläne verlangen oft einen Prozentsatz davon, etwa 75 %.`)
};

const it_it2_exercise_sheet_percent_note = /** @type {(inputs: Exercise_Sheet_Percent_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calcolato dalla tua forza massima stimata (${i?.loadText}), il peso che potresti sollevare una sola volta. I programmi spesso ne chiedono una percentuale, come il 75%.`)
};

/**
* | output |
* | --- |
* | "Worked out from your estimated max strength ({loadText}), the weight you could lift once. Programmes often ask for a percentage of it, such as 75%." |
*
* @param {Exercise_Sheet_Percent_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_percent_note = /** @type {((inputs: Exercise_Sheet_Percent_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Percent_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_percent_note(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_percent_note(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_percent_note(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_percent_note(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_percent_note(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_percent_note(inputs)
	return en_us2_exercise_sheet_percent_note(inputs)
});
export { exercise_sheet_percent_note as "exercise-sheet.percent_note" }